import React, { useCallback, useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { fetchAnalyticsView } from "../ExtendedAnalytics/api"
import { DASHBOARD_FEEDBACK_QUERY, FeedbackCards, feedbackKpis } from "../TournamentFeedback/FeedbackCards"

// The Dashboard's „Tournament feedback” group (docs/design/tournament-feedback, screenshot 08): the last 30 days of the
// view=tournament-feedback snapshot, separate from the review view so the existing cards stay as they are. It is read
// once by ReviewOverview and placed under the review cards; a 401 or 403 hides it.
export function useFeedbackOverview() {
  const [state, setState] = useState({ status: "loading" })
  const [attempt, setAttempt] = useState(0)
  useEffect(() => {
    let active = true
    setState({ status: "loading" })
    fetchAnalyticsView(DASHBOARD_FEEDBACK_QUERY).then(response => {
      if (active) setState({ status: "ready", snapshot: response.data })
    }).catch(error => {
      if (active) setState({ status: [401, 403].includes(error?.response?.status) ? "forbidden" : "error" })
    })
    return () => { active = false }
  }, [attempt])
  const retry = useCallback(() => setAttempt(value => value + 1), [])
  return { state, retry }
}

export default function FeedbackOverview({ state, onRetry }) {
  if (!["ready", "error"].includes(state.status)) return null
  const kpis = feedbackKpis(state.snapshot)
  return <section aria-labelledby="feedback-overview-title" className="mb-3">
    <div className="d-flex align-items-baseline justify-content-between flex-wrap">
      <h3 className="font-size-16" id="feedback-overview-title">Tournament feedback</h3>
      <Link to="/tournament-feedback/analysis">Open the feedback analysis</Link>
    </div>
    {state.status === "error" && <div role="alert"><p>Tournament feedback analytics are temporarily unavailable.</p>
      <button type="button" className="btn btn-outline-primary" onClick={onRetry}>Try again</button></div>}
    {state.status === "ready" && (state.snapshot?.metadata?.empty || !kpis.length
      ? <p className="text-muted">No tournament feedback in this selection.</p>
      : <FeedbackCards kpis={kpis} compact />)}
  </section>
}
